const tradeOnPurchaseImg = 'https://img.sm360.ca/images/showroom360/trade-in-widget/trade-on-purchase.png';
const sellYourVehicleImg = 'https://img.sm360.ca/images/showroom360/trade-in-widget/sell-your-vehicle.png';
const notSureImg = 'https://img.sm360.ca/images/showroom360/trade-in-widget/not-sure.png';

export { tradeOnPurchaseImg, sellYourVehicleImg, notSureImg };
